import { useScreenSizeContext } from '@/components/ScreenSize.context';
import styles from './CarouselContainer.module.scss';
import { DesktopReturnType, MobileAndTabletReturnType, useCarouselContext } from './useCarouselContext';

export const CarouselContainer = ({ renderComponent, withGap, withFreeScrolling, title }) => {
	const isMobileOrTablet = useScreenSizeContext().isMobileOrTablet;

	const carouselContext = useCarouselContext({
		withGap,
		withTouch: isMobileOrTablet,
		withFreeScrolling: withFreeScrolling,
	});

	const Component = renderComponent({ ...carouselContext, withGap });

	const componentClassNames = [styles.component, withFreeScrolling && styles['free-scrolling']].filter(Boolean).join(' ');

	const containerProps = !withFreeScrolling
		? {
				onTouchStart: (e) => (carouselContext as MobileAndTabletReturnType).onTouchStart(e),
				onTouchMove: (e) => (carouselContext as MobileAndTabletReturnType).onTouchMove(e),
				onTouchEnd: (carouselContext as MobileAndTabletReturnType).onTouchEnd,
			}
		: {};

	return (
		<div
			className={styles.container}
			ref={(containerRef) => {
				carouselContext.getContainerRef(containerRef);
			}}
			{...containerProps}
		>
			{title && <div className={styles.title}>{title}</div>}
			{carouselContext.state.clickNumber.nextClickNumber >= 1 && !isMobileOrTablet && (
				<div
					className={styles['icon-left-container']}
					onClick={(carouselContext as DesktopReturnType).handleScrollPrevious}
				>
					<div className={styles['icon-previous']} />
				</div>
			)}
			<div className={componentClassNames}>{Component}</div>
			{!carouselContext.state.isAtLastChild && !isMobileOrTablet && (
				<div className={styles['icon-right-container']} onClick={(carouselContext as DesktopReturnType).handleScrollNext}>
					<div className={styles['icon-next']} />
				</div>
			)}
		</div>
	);
};

export default CarouselContainer;
